import { Box, Link } from '@mui/material'
import facebook from './svg/facebook.svg';

export default function Facebook({to}) {
  return (    
    <Link href={to}>
      <Box component="img" sx={{ width: '15px', display:'inline-block'}} alt="NOB 4.0" src={facebook} />
    </Link>
  )
}